import { Injectable } from '@angular/core';
import { Events} from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { DataProvider } from '../data/data';
import { AngularFirestore, AngularFirestoreCollection,AngularFirestoreDocument } from '@angular/fire/firestore';
import { first } from 'rxjs/operators';

/*
  Generated class for the LabelProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LabelProvider {
  
  public labels:any = {};
  public activeLan : string = 'en';
  userSubs:any;
  keys:any = [
  "ACTION_ISSUE",
"ACTION_ISSUE_COMPLED_MSG",
"ACTION_ISSUE_REJECTED_MSG",
"ACTION_ITEMS_ABBR",
"ACTION_ITEMS_COMPLETED",
"ACTION_PLAN",
"ACTION_PLAN_COMPLETED_TIMELINE_MSG",
"ACTION_PLAN_CONTNIUE_TIMELINE_QUE",
"ACTION_PLAN_CREATED_TIMELINE_MSG",
"ACTION_PLAN_PROCESS_MESSAGE",
"ACTION_PLAN_VERIFIED_TIMELINE_MSG",
"ACTION_REPORT_GENERATED_TIMELINE_MSG",
"ACTION_REPORT_NA_POPUP_MESSAGE",
"ACTION_REPORT_NA_POPUP_TITLE",
"ACTIONS_CLOSED_TXT",
"ACTIONS_OPENED_TXT",
"ADD_DEALER_PERSONNEL",
"ADD_DEALERSHIP_TITLE",
"ADD_IMAGE_USING",
"ADD_NEW",
"ADD_NEW_BTN",
"ADD_OEM_FIELD_REP_TITLE",
"ADD_PERSONNEL_TXT",
"ADD_PREMISES",
"ADD_PREMISES_TXT",
"ADDRESS",
"ALBUMS",
"APPLY_TXT",
"APR",
"AREAS_TXT",
"ASSESSMENT_TXT",
"ASSESSOR",
"ATTACH_EVIDENCE_BTN",
"AUDIT",
"AUDIT_COMPLETED_TIMELINE_MSG",
"AUDIT_COMPLETED_TXT",
"AUDIT_DATE",
"AUDIT_DELIVERY",
"AUDIT_END_DATE_TXT",
"AUDIT_FINISHED_TIMELINE_MSG",
"AUDIT_NAME",
"AUDIT_PLAN_INCOMPLETE",
"AUDIT_PROJECTS_TITLE",
"AUDIT_REPORT_GENERATED_TIMELINE_MSG",
"AUDIT_REPORT_TITLE",
"AUDIT_SCHEDULE_FAILED",
"AUDIT_SCHEDULE_SUCCESS",
"AUDIT_SCHEDULED_TXT",
"AUDIT_START_DATE_TXT",
"AUDIT_START_FAILED",
"AUDIT_STARTED_TIMELINE_MSG",
"AUDIT_STATUS",
"AUDIT_TXT",
"AUDIT_TYPE",
"AUDITS",
"AUDITS_COMPLETED_TXT",
"AUDITS_OUTSTANDING_TXT",
"AUDITS_PENDING_TXT",
"AUDITS_TITLE",
"AUDITS_TXT",
"AUG",
"AVAILABLE_STATUS",
"AVG_AUDIT_SCORE_TXT",
"BACK_BTN",
"CALL_TXT",
"CAMERA",
"CANCEL",
"CHECK_AUDIT_SUMMARY_BTN",
"CHECK_ISSUE",
"CLEAR_BTN",
"CLOSE_BTN",
"CLOSE_ISSUE",
"COMMENT",
"COMPLETE_ACTION_PLAN_TIMELINE_BTN",
"COMPLETE_ACTION_PLAN_TIMELINE_QUE",
"COMPLETE_AUDIT_SECTIONS_TIMELINE_MSG",
"COMPLETED_ABBR",
"COMPLETED_AUDITS_TITLE",
"COMPLETED_TXT",
"CONFIRM_PASSWORD_TXT",
"CONNECT_TO_INTERNET",
"CONTACTS_TXT",
"CONTINUE",
"COUNTRY_CODE",
"CREATED_ON",
"DATE_AT_TIME_TXT",
"DATE_TXT",
"DEALER",
"DEALER_ADDRESS",
"DEALER_INVITE_FAILURE_MSG",
"DEALER_INVITE_SUCCESS_MSG",
"DEALER_MANAGER_ADD_INCOMPLETE_MESSAGE",
"DEALER_NAME",
"DEALER_PERSONNEL",
"DEALER_PERSONNEL_ADD_SUCCESS_MESSAGE",
"DEALER_PERSONNEL_UPDATE_FAILED_MESSAGE",
"DEALER_PERSONNEL_UPDATE_SUCCESS_MESSAGE",
"DEALER_TXT",
"DEALERS_LIST_TXT",
"DEALERSHIP",
"DEALERSHIP_ADD_FAILED_MESSAGE",
"DEALERSHIP_ADD_INCOMPLETE_MESSAGE",
"DEALERSHIP_ADD_SUCCESS_MESSAGE",
"DEALERSHIP_NAME",
"DEALERSHIP_TXT",
"DEALERSHIP_UPDATE_FAILED_MESSAGE",
"DEALERSHIP_UPDATE_SUCCESS_MESSAGE",
"DEC",
"DESCRIPTION_TXT",
"DESIGNATION",
"DISCUSSION",
"DOWNLOAD_PDF_BTN",
"DUE_DATE",
"DUE_DATE_MSG",
"EDIT_DEALER_PERSONNEL",
"EDIT_DEALERSHIP_TITLE",
"EDIT_OEM_FIELD_REP_TITLE",
"EDIT_PREMISES",
"EMAIL",
"EMAIL_ADDRESS",
"EMAIL_PASSWORD_EMPTY_MESSAGE",
"END_DATE",
"END_DATE_TIME_BTN",
"END_DATE_TXT",
"ENTER_EMAL_PLACEHOLDER",
"ENTER_OTP_TXT",
"EVENT_POSTED_BY",
"FAILED",
"FEB",
"FINISH_AUDIT_TIMELINE_QUE",
"FINSIH_AUDIT_TIMELINE_BTN",
"FORGOT_PASSWORD",
"FROM",
"FULL_NAME",
"GALLERY",
"GET_DIRECTIONS_TXT",
"GET_NOTIFICATION",
"GET_SIGNOFF_TIMELINE_MSG",
"GOOD_TXT",
"HIGH_IMPACT_TXT",
"IN_PROGRESS_ABBR",
"IN_PROGRESS_TXT",
"INCOMPLETE_TITLE",
"INFORMATION",
"INVALID_DATE_MESSAGE",
"INVALID_DATE_TITLE",
"INVALID_EMAIL_PASSWORD",
"INVALID_OTP_MESSAGE",
"INVALID_OTP_TITLE",
"INVALID_PASSWORD_LENGTH_MESSAGE",
"INVALID_PASSWORD_LENGTH_TITLE",
"INVITE_TXT",
"ISSUE",
"ISSUE_DESCRIPTION",
"ISSUE_DETAILS",
"JAN",
"JUL",
"JUN",
"LAST_AUDIT_TITLE",
"LAST_AUDIT_TXT",
"LAUNCH_AUDIT_BTN",
"LOCATION",
"LOGIN",
"LOGIN_BTN",
"LOGIN_FAILED_MESSAGE",
"LOGOUT",
"LOW_IMPACT_TXT",
"MANDATORY",
"MAR",
"MARKETS_TXT",
"MAY",
"MEDIUM_IMPACT_TXT",
"MESSAGE_TXT",
"MIN_CHARS_PASSWORD_MSG",
"MULTIPLE_AUDITS",
"NA_TITLE",
"NA_TXT",
"NAME",
"NATION_TXT",
"NEW_PASSWORD_TXT",
"NEXT_BTN",
"NG_TITLE",
"NO_AUDITS",
"NO_BTN",
"NO_EMAIL_PASSWORD_MESSAGE",
"NO_LAST_AUDIT_MSG",
"NOT_APPLICABLE_TXT",
"NOT_GOOD_TXT",
"NOT_SCHEDULED_ABBR",
"NOT_SCHEDULED_TXT",
"NOT_STARTED_ABBR",
"NOT_STARTED_TXT",
"NOTIFICATIONS_TITLE",
"NOTIFY_LATER",
"NOTIFY_NOW",
"NOV",
"OCT",
"OEM_EXTERNAL",
"OEM_FIELD_REP",
"OEM_FIELD_REP_ADD_FAILED_MESSAGE",
"OEM_FIELD_REP_ADD_INCOMPLETE_MESSAGE",
"OEM_FIELD_REP_ADD_SUCCESS_MESSAGE",
"OEM_FIELD_REP_UPDATE_FAILED_MESSAGE",
"OEM_FIELD_REP_UPDATE_SUCCESS_MESSAGE",
"OK",
"OK_GOT_IT_BTN",
"OK_TITLE",
"OUTSTANDING_TXT",
"PARTIAL_TXT",
"PARTICIPATE_TXT",
"PASSWORD",
"PASSWORD_DIFFERENT_MESSAGE",
"PASSWORD_DIFFERENT_TITLE",
"PASSWORD_UPDATE_FAILED_MESSAGE",
"PASSWORD_UPDATE_FAILED_TITLE",
"PASSWORD_UPDATED_TXT",
"PAST_PENDING_AUDITS",
"PENDING_ACTION_ITEMS_TXT",
"PENDING_AUDITS_TITLE",
"PERSONNEL_TITLE",
"PHONE_NO",
"PREMISES_ADD_FAILED_MESSAGE",
"PREMISES_ADD_INCOMPLETE_MESSAGE",
"PREMISES_ADD_SUCCESS_MESSAGE",
"PREMISES_TITLE",
"PREMISES_UPDATE_SUCCESS_MESSAGE",
"PRINCIPAL_NAME_TXT",
"PROFILE_UPDATED_MESSAGE",
"PROGRESS_TEXT",
"PROGRESS_PER",
"PROJECT_NAME",
"PROJECT_NAME_DETAILS",
"RECTIFIED_TXT",
"REGIONS_TXT",
"REMAINING_AUDITS",
"REMEMBER_ME",
"REPORTS_FILTER_TITLE",
"REPORTS_TITLE",
"RESCHEDULE",
"RESET_PASSWORD_TITLE",
"RESPONSIBLE_PERSON",
"SAVE",
"SAVE_PROFILE",
"SCHEDULE_AUDIT",
"SCHEDULE_AUDIT_BTN",
"SCHEDULE_AUDIT_DATES_INCOMPLETE_MESSAGE",
"SCHEDULE_AUDIT_INCOMPLETE_MESSAGE",
"SCHEDULE_AUDIT_TITLE",
"SCORE_TXT",
"SEARCH_TXT",
"SECTION",
"SECTIONS_COMPLETED_TIMELINE_MSG",
"SELECT",
"SELECT_DEALERS",
"SELECT_LOCATION",
"SELECT_ZONE",
"SELF_AUDIT",
"SEND_EMAIL_TXT",
"SEP",
"SETTING",
"SIGNOFF_TIMELINE_MSG",
"START_AUDIT_BTN",
"START_DATE",
"START_DATE_TIME_BTN",
"START_DATE_TXT",
"STATUS",
"SUBMIT_BTN",
"SUCCESS",
"TIME_PERIOD_TXT",
"TO",
"TODAY_AUDIT_TITLE",
"TOTAL_DEALERS_TXT",
"TTL_TITLE",
"UPCOMING_AUDITS",
"VACATION",
"VERIFIED",
"VERIFY_ACTION_PLAN_BTN",
"VIEW_ACTION_ITEMS_BTN",
"VIEW_ACTION_PLAN_BTN",
"VIEW_ACTION_REPORT_TIMELINE_BTN",
"VIEW_AUDIT",
"VIEW_AUDIT_BTN",
"VIEW_AUDIT_REPORT_TIMELINE_BTN",
"VIEW_LAST_AUDIT_BTN",
"YES_BTN",
"YOUR_COMMENT",
"ZONE",
"CLOSE_ISSUE_TITLE",
"CLOSE_ISSUE_MSG",
"SHOW_UNANSWERED_ITEMS",
"PROGRESS_TXT",
"AUDIT_SCORE",
"PREMISES_TXT",
"DEALER_PRINCIPAL",
"APPROVER_TXT",
"SIGNATURE_TXT",
"SELECT_PERSON_TXT",
"DEALER_PERSON",
"GET_SIGNATURES_TIMELINE_MSG",
"SIGNATURES_TIMELINE_MSG",
"SAVE_SIGNATURES",
"SUBMIT_VALIDATION_ADMIN_MESSAGE",
"SUBMIT_VALIDATION_ADMIN_BTN",
"AUDIT_SUBMITTED_FOR_VALIDATION_ADMIN",
"VALIDATE_AUDIT_MESSAGE",
"VALIDATION_COMPLETED_MESSAGE",
"VALIDATION_COMPLETED_BTN",
"CHANGES",
"NO_CHANGES_MESSAGE",
"TASKS",
"VALIDATE_AUDIT",
"FINISH_VALIDATION",
"QUESTION",
"UPDATED_ON",
"COMMENT_UPDATED_FROM",
"COMMENT_UPDATED_TO",
"EVIDENCE_ADDED",
"EVIDENCE_DELETED",
"RATING_UPDATED_FROM",
"SELECT_APPROVERS_MESSAGE",
"REVIEW_AUDIT",
"SUBMIT_FOR_APPROVAL",
"AUDIT_SUBMITTED_FOR_APPROVALS",
"APPROVE_AUDIT_MESSAGE",
"UPDATE_APPROVERS_MESSAGE",
"UPDATE_APPROVERS",
"APPROVE_AUDIT",
"START_APPROVAL",
"AUDIT_APPROVAL_STARTED_BY",
"AUDIT_APPROVAL_COMPLETED_MSG",
"APPROVAL_COMPLETED_BTN",
"AUDIT_SUBMITTED_FOR_OTHER_APPROVALS",
"LEGEND",
"RATING"
  ]
  constructor(public translateService:TranslateService,private storage:Storage,public events: Events,private afs: AngularFirestore,public dataProvider:DataProvider) {
    

    // afs.firestore.settings({timestampsInSnapshots: true});

     
  }

   async intializeSubscriptions(){

   	// this.events.subscribe('user:getLan', () => {

    //   this.getActiveLan();
    // });
   	this.events.subscribe('user:lan', (lan, uid) => {

      this.setActiveLan(lan, uid);
    });
    //  this.events.subscribe('user:setInitialLan', (lan) => {

    //   this.setInitialLan(lan);
    // });
    // this.events.subscribe('user:updateLan', (lan) => {

    //   this.updateLan(lan);
    // }); */


    

    this.intialiseTranslateService();

    

    
   

   }

   async intialiseTranslateService(){

    var activeLan = await this.storage.get('lan');

    if(activeLan){
      this.translateService.use(activeLan);

    }
    else{
       let settings:any =  await this.afs.collection('config').doc('settings').valueChanges().pipe(first()).toPromise();
         console.log('2',settings);
         await this.storage.set('lan', settings.language);
         this.translateService.use(settings.language);
    }
      

    this.translateService.get(this.keys).subscribe(value => { 

       this.labels = value;
       
    }); 


   }

   /*async getActiveLan(){
   	 
     var activeLan = await this.storage.get('lan');
     if(activeLan){
      this.activeLan = activeLan;
     }
   	  
   	 this.events.publish('user:lan',this.activeLan);
   }*/

   async setActiveLan(lan, uid){
   	await this.storage.set('lan', lan);
  	this.translateService.use(lan);

    this.intialiseTranslateService();

     if(uid && !this.userSubs){
        this.userSubs =  this.afs.collection('users').doc(uid).valueChanges().pipe().subscribe( async (user:any) => {  

            if(user && user.language && user.language != ''){
               console.log('user',user);
               await this.storage.set('lan', user.language);
              this.intialiseTranslateService();
            }
         });
     }
   }

   /*
   async setInitialLan(lan){

    console.log("initialising lan:"+lan);
    await this.storage.set('lan', lan);
    this.translateService.use(lan);
    this.intialiseTranslateService();
   }

   async updateLan(lan){

	   	var userLan = 'English';
	  	if(lan == 'cs'){
	  		userLan = 'Czech';
	  	}
	  	else if(lan == 'de'){
	  		userLan = 'German';
	  	}
	  	else if(lan == 'es'){
	  		userLan = 'Spanish';
	  	}
	  	else if(lan == 'fr'){
	  		userLan = 'French';
	  	}
	  	else if(lan == 'it'){
	  		userLan = 'Italian';
	  	}
	  	else if(lan == 'nl'){
	  		userLan = 'Dutch';
	  	}

	  	if(this.data && this.data.uid){
        
	  		await this.afs.collection('users').doc(this.data.uid).update({language : userLan});
	  	}
   } */

}



// WEBPACK FOOTER //
// ./src/providers/label/label.ts